

const formats = [
  "", //undefined
  "(###) ###-####", // US (1)
  "### #### ####", //UK (2)
  "###-###-####", //CA (3)
  "(##) #### ####", //AU (4)
];

const fullLengths = [
    0, //undefined
    11, // US (1)
    13, //UK (2)
    11, //CA (3)
    12, //AU (4)
  ];

export function GetPhoneNumberLength(countryId:number,usePrefix?:boolean){

    let str = formats[countryId]??formats[1];
    if(usePrefix){
        str = GetPrefix(countryId)+str;
    }

  
    return (str.length);
}


export function GetPhoneNumberLenthNoFormatting(countryId:number){

    return fullLengths[countryId];

}

export function GetPrefix(countryId:number){
    
    let prefix = "";
    switch(countryId){
        case 1:
            prefix = "+1 ";
            break;
        case 2://UK
            prefix = "+44 ";
            break;
        case 3://CA
        prefix = "+1 ";
            break;
        case 4:
            prefix = "+61 ";
            break;
        default:
            break;
    }
    return prefix;
}

export default function GetFormattedPhoneNumber(teleString:string,groupId:number,includePrefix?:boolean){

    if(teleString==""&&includePrefix){
        return GetPrefix(groupId);
    }

 
    let prefix = GetPrefix(groupId);
    let numPrefix = prefix.replace(/[^0-9]/g, '');

    if(teleString.startsWith(numPrefix)){
        teleString = teleString.replace(numPrefix,"");
    }

    let compareString = formats[groupId]??"";

    teleString = teleString.replace(/[^0-9]/g, '');

    let newString = "";
  

    let tIndex = 0;
    for(let i = 0;i<compareString.length;i++){
            
            if(tIndex>=teleString.length){
                break;
            }

            if(compareString[i] == "#"){
                newString+=teleString[tIndex];
                tIndex++;
            }
            else{
                newString+=compareString[i];
            }
    }
    
    if(!newString.startsWith("+")){
        newString = GetPrefix(groupId) + newString;
    }
    
    if(includePrefix){
        teleString = prefix+teleString;
    }

    return newString;

}

